import { themeConstants } from './constants';

const shadows = themeConstants.shadows;

export default shadows;
